<template>
  <div>
    <div class="gacha-container">
      <div class="top-bar">
        <div class="left-empty">
          <el-button type="warning" @click="onMyGacha" size="mini" plain>
            <i class="el-icon-reading"></i> 我的收藏
          </el-button>
        </div>
        <h2 class="title">幸運抽卡</h2>
        <div class="right-empty"></div>
      </div>

      <!-- Loading 遮罩弹窗 -->
      <div v-if="loading" class="loading-mask">
        <div class="loading-box">Loading, please wait...</div>
      </div>
      <div v-else>
        <div class="top-bar">
          <div class="left-empty">
            <div class="filter-group">
              <el-button
                  class="glow-btn"
                  size="small"
                  :type="titleId === null ? 'warning' : 'default'"
                  @click="titleId=null;goGetCards()">
                全部系列
              </el-button>
              <el-button
                  class="glow-btn"
                  v-for="item in titles"
                  :key="item.id"
                  :type="titleId === item.id ? 'warning' : 'default'"
                  @click="goGetCards(item.id)"
                  size="small"
              >
                {{ item.name }}
              </el-button>
            </div>
          </div>
          <div class="right-empty"></div>
        </div>

        <div class="grid-box">
          <div
              class="card-item"
              :class="getCardClass(item)"
              v-for="(item) in cardList"
              :key="item.id"
          >
            <img class="card-img" :src="require('@/assets/images/kaback.png')" alt="" />
<!--            <div class="card-name">{{ item.name }}</div>-->
<!--            <div class="card-rate card-tag" :class="`tag-${item.propertyId}`">{{ item.propertyName }}</div>-->
          </div>
        </div>
      </div>

      <!-- 悬浮抽卡按钮 固定屏幕正中 -->
      <div class="float-lottery-wrapper">
        <button
            class="table-button"
            :disabled="rolling"
            @click="startLottery"
        >
          {{ rolling ? "抽卡中..." : "開始抽卡" }}
        </button>
        <span class="chance-text">您還有{{userCardsRoleNum}}次抽卡機會!</span>
      </div>

      <!-- 获奖弹窗 - 无边框透明版 + X关闭 -->
      <div class="modal-mask no-border-modal" v-show="showModal" @click="showModal=false">
        <div class="modal-content" @click.stop>
          <!-- 关闭X -->
          <div class="close-x" @click="showModal=false">×</div>
          <img :src="gotCard.image" class="win-img no-border-img"/>
          <div class="win-text">恭喜獲得：{{gotCard.name}}</div>
          <div class="card-tag" :class="`tag-${gotCard.propertyId}`">{{ gotCard.propertyName }}</div>
          <div class="card-tag" :class="`tag-${gotCard.propertyId}`">{{ gotCard.titleName }}</div>
          <div style="color:#fff;margin-top:10px;">{{ gotCard.content }}</div>

          <el-button type="warning" @click="onMyGacha" size="mini" plain style="margin-top:10px;">
            <i class="el-icon-reading"></i> 我的收藏
          </el-button>
        </div>
      </div>

      <!-- 无机会弹窗 -->
      <div
          class="modal-mask"
          v-show="notRoleShowModal"
          @click="notRoleShowModal = false"
      >
        <div class="modal-content" @click.stop>
          <div class="win-title">提示</div>
          <div class="win-text">您現在沒有抽卡機會</div>
          <div class="win-sub-title">如何獲取抽卡機會：</div>
          <div class="win-desc">
            1、在冒險、圖書館、作業任意模式下練習獲得2顆星或以上，可獲取一次抽卡機會
          </div>
          <el-button class="confirm-btn" size="small" @click="notRoleShowModal = false">
            知道了
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCards, indexTitle, getUserCardsRoleNum,saveCardsUser } from "@/api/cards";

export default {
  data() {
    return {
      loading: true,
      userCardsRoleNum: 0,
      activeIndex: -1,
      titleId: null,
      titles: [],
      rolling: false,
      timer: null,
      showModal: false,
      notRoleShowModal: false,
      winName: '',
      winImage: '',
      gotCard:{},
      cardList: [],
      runOrder: [0, 1, 2],
      audioStart: null,
      audioRoll: null,
      audioWin: null,
      total: 0,
      listQ: {
        _page1: 1,
        _page2: 1,
        _limit: 100,
      },
      cardsUser: {
        userId: null,
        cardId: null,
      },
    };
  },
  mounted() {
    this.audioStart = new Audio(require('@/assets/vedio/roll.mp3'));
  },
  created() {
    this.getUserCardsRoleNum();
    this.indexTitle();
    this.getCards();
  },
  methods: {
    getCardClass(item) {
      const classes = [];
      const propertyId = item.propertyId;
      if (propertyId === 1) classes.push('rarity-1');
      else if (propertyId === 2) classes.push('rarity-2');
      else if (propertyId === 3) classes.push('rarity-3');
      else if (propertyId === 4) classes.push('rarity-4');
      else if (propertyId === 5) classes.push('rarity-5');
      else classes.push('rarity-default');

      if (this.activeIndex === this.cardList.indexOf(item)) {
        classes.push('active');
      }
      return classes;
    },
    goGetCards(id) {
      this.titleId = id;
      this.getCards();
    },
    getCards() {
      let form = {
        titleId: this.titleId,
        _page: this.listQ._page2 - 1,
        _limit: this.listQ._limit,
      };
      getCards(form).then((v) => {
        this.cardList = v.data;
        this.total = Number(v.headers["x-total-count"]);
        this.loading = false;
      });
    },
    indexTitle() {
      indexTitle().then((v) => {
        this.titles = v.data;
      });
    },
    async getUserCardsRoleNum() {
      const res = await getUserCardsRoleNum();
      this.userCardsRoleNum = res.data;
    },
    saveCardsUser() {
      saveCardsUser(this.cardsUser);
    },
    onMyGacha() {
      const newPath = "/myGacha";
      if (this.$route.path !== newPath) {
        this.$router.push({ path: newPath });
      }
    },
    playSound(type) {
      if (type === 'start') {
        this.audioStart.currentTime = 0;
        this.audioStart.play();
      }
      if (type === 'win') {
        this.audioStart.pause();
        this.audioStart.currentTime = 0;
      }
    },
    getRandomCard() {
      let random = Math.random() * 100;
      let total = 0;
      for (let i = 0; i < this.cardList.length; i++) {
        total += parseFloat(this.cardList[i].probability);
        if (random < total) {
          return i; // 返回 → 卡片索引（正确）
        }
      }
      return 0;
    },
    async startLottery() {
      // 👉 第一步：抽奖前【先刷新最新次数】，必须等待完成
      await this.getUserCardsRoleNum();

      if (this.userCardsRoleNum <= 0) {
        this.notRoleShowModal = true;
        return;
      }
      if (this.rolling) return;
      this.rolling = true;

      this.playSound('start');

      let count = 0;
      const speed = 60;
      const duration = 5000;

      // ✅ 第一步：先算出“真正抽到哪张卡”
      const randomCardIndex = this.getRandomCard();
      const targetCard = this.cardList[randomCardIndex];

      // ✅ 第二步：找到这张卡“在转盘格子里对应的位置”
      // 假设你的转盘顺序和 cardList 一致
      const finalIndex = randomCardIndex;

      // 开始转动动画
      this.timer = setInterval(() => {
        this.activeIndex = count % this.cardList.length;
        count++;

        if (count * speed >= duration) {
          clearInterval(this.timer);

          // ✅ 最终停在：抽到的卡片索引
          this.activeIndex = finalIndex;

          this.rolling = false;
          this.gotCard = targetCard;
          this.showModal = true;
          this.playSound('win');
          this.cardsUser.cardId = targetCard.id;
          this.saveCardsUser();
          this.getUserCardsRoleNum();
        }
      }, speed);
    },
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
};
</script>

<style scoped>
/* Loading 遮罩弹窗 */
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
}
.loading-box {
  background: #fff;
  padding: 25px 40px;
  border-radius: 12px;
  font-size: 16px;
  color: #333;
}

.gacha-container {
  max-width: 860px;
  margin: 50px auto;
  text-align: center;
  position: relative;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  position: relative;
  z-index: 1999 !important;
}

.left-empty {
  flex: 1;
  text-align: left;
}

.right-empty {
  flex: 1;
  text-align: right;
}

.title {
  flex: 2;
  text-align: center;
  color: #fff;
  text-shadow: 0 0 10px rgba(255, 215, 0, 0.7);
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 3rem;
  font-weight: 700;
  font-family: "GenSenRoundedTW", "Helvetica", "Arial";
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.8);
}

.grid-box {
  display: grid;
  grid-template-columns: repeat(5, 161px);
  grid-template-rows: repeat(5, 228px);
  gap: 12px;
  justify-content: center;
}

/* ========== 卡片样式：无边框 + 黑色发光底 ========== */
.card-item {
  position: relative;
  background: #000;
  border: none;
  border-radius: 5px;
  padding: 0;
  overflow: hidden;
  transition: all 0.1s ease;
  box-shadow: 0 0 20px rgba(255,255,255,0.15);
}

.card-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 1;
}

.card-name,
.card-rate {
  position: relative;
  z-index: 2;
  color: #fff;
  text-shadow: 0 0 3px #000;
}

.card-name {
  font-size: 16px;
  font-weight: bold;
  margin-top: 15px;
}

.card-rate {
  font-size: 12px;
  color: #eee;
  margin-top: 4px;
}

.card-item.active {
  transform: scale(1.05);
  box-shadow: 0 0 40px 10px currentColor !important;
  border-color: #fff !important;
}

.rarity-1 {
  color: #fff;
}
.rarity-2 {
  color: #fff;
}
.rarity-3 {
  color: #fff;
}
.rarity-4 {
  color: #fff;
}
.rarity-5 {
  color: #fff;
}
.rarity-default {
  color: #fff;
}

.table-button {
  background: #fcc03a;
  box-shadow: 0px 0.5rem 0 #c28c00;
  border: none;
  border-radius: 2.75rem;
  font-size: 1.2rem;
  line-height: 2rem;
  padding: 0.5rem 2rem;
  color: white;
}

.table-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ---------- 悬浮抽卡按钮 ---------- */
.float-lottery-wrapper {
  position: fixed;
  left: 50%;
  bottom: 8vh;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.chance-text {
  font-size: 14px;
  color: #fff;
  text-shadow: 0 1px 3px #000;
}

/* ---------- 无边框透明弹窗 ---------- */
.no-border-modal .modal-content {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  width: auto !important;
  border: none !important;
}
.no-border-img {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
}
/* 关闭X */
.close-x {
  position: absolute;
  right: -10px;
  top: -10px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0,0,0,0.5);
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
}

.modal-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  text-align: center;
  background: #fff;
  padding: 20px;
  position: relative;
  width: 320px;
  max-width: 360px;
  border-radius: 24px;
}

.win-img {
  display: block;
  width: 100%;
  border-radius: 18px;
  margin-bottom: 20px;
}

.win-text {
  font-size: 20px;
  font-weight: bold;
  margin: 15px 0;
  color: #ff6600;
}

.win-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
}

.win-sub-title {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  text-align: left;
}

.win-desc {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
  text-align: left;
  margin-bottom: 24px;
}

.confirm-btn {
  background: #ff7d00 !important;
  border-color: #ff7d00 !important;
  color: #fff !important;
  border-radius: 20px;
}
.card-tag {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  margin: 2px;
}
.tag-1 { background: #999; }
.tag-2 { background: #9370db; }
.tag-3 { background: #ffd700; }
.tag-4 { background: rgb(246 134 44); }
.tag-5 { background: #7cb8ff; }
</style>